import SettingsDrawer from './drawer';
//
import ThemeContrast from './ThemeContrast';
import ThemeRtlLayout from './ThemeRtlLayout';
import ThemeColorPresets from './ThemeColorPresets';
import ThemeLocalization from './ThemeLocalization';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export default function ThemeSettings({ children }: Props) {
    const { isAdmin } = useAuth();

    return (
        <ThemeColorPresets>
            <ThemeContrast>
                <ThemeLocalization>
                    <ThemeRtlLayout>
                        {children}
                        {/* {isAdmin && <SettingsDrawer />} */}
                    </ThemeRtlLayout>
                </ThemeLocalization>
            </ThemeContrast>
        </ThemeColorPresets>
    );
}
